import { render, staticRenderFns } from "./seat-navigation-accordion-block.vue?vue&type=template&id=068e316d&scoped=true"
import script from "./seat-navigation-accordion-block.vue?vue&type=script&lang=js"
export * from "./seat-navigation-accordion-block.vue?vue&type=script&lang=js"
import style0 from "./seat-navigation-accordion-block.vue?vue&type=style&index=0&id=068e316d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068e316d",
  null
  
)

export default component.exports